import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
// import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';


@Component({
  selector: 'app-gismistoggle',
  templateUrl: './gismistoggle.component.html',
  styleUrls: ['./gismistoggle.component.scss']
})
export class GismistoggleComponent implements OnInit {
  moduleName : any;
  isActive : any;
  view : any;
  lang: string;
  stateUrlId: any;
  deviceInfo: any;
  constructor(
    private router: Router,
    // public translate: TranslateService,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) {
    // const browserLang = translate.getBrowserLang();
    this.lang = localStorage.getItem("lang");
    this.lang = (this.lang=='en' || this.lang=='te') ? this.lang : 'en';
    // this.utils.setLanguage(browserLang);
    localStorage.setItem("lang", this.lang)
    // translate.use(browserLang.match(/en|te|hi/) ? browserLang : 'en');
    this.stateUrlId = this.route.snapshot.paramMap.get('id');
  }

  ngOnInit() {
    this.lang = localStorage.getItem("lang");
    // this.translate.use(this.lang.match(/en|te|hi/) ? this.lang : 'en');
    this.moduleName = this.router.url.split('/')[1];
    this.view = this.router.url.split('/')[2];
    this.deviceInfo = this.deviceService.getDeviceInfo();
  }

  routeChange(item) {
    if(this.view != item){
      this.isActive = !this.isActive;
      const moduleName = this.router.url.split('/')[1];
      const stateId = this.router.url.split('/')[3];
      // console.log(this.router.url.split('/'))
      this.router.navigate([moduleName, item, stateId]);
    }
  }

  translation(language) {
    // this.translate.use(language);
    this.lang = language;
    localStorage.setItem("lang", this.lang)
    // this.utils.setLanguage(this.lang);
  }

}
